<ng-container *ngIf="count">
  <span
    class="op-tab-count"
    *ngIf="count > 0"
    [textContent]="count"
  ></span>
</ng-container>